import { render } from "./CookiesHome.vue?vue&type=template&id=da742412&scoped=true"
import script from "./CookiesHome.vue?vue&type=script&lang=js"
export * from "./CookiesHome.vue?vue&type=script&lang=js"

import "./CookiesHome.vue?vue&type=style&index=0&id=da742412&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Test\\Desktop\\gthconsult-siteV2\\front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da742412"]])

export default __exports__